function isPlainObject(value) {
  if (!value || typeof value !== 'object') {
    return false;
  }

  return Object.prototype.toString.call(value) === '[object Object]';
}

function isUppercaseLetter(char) {
  return char >= 'A' && char <= 'Z';
}

function isLowercaseLetter(char) {
  return char >= 'a' && char <= 'z';
}

function getLeadingUppercasePrefixLength(key) {
  if (!key || !isUppercaseLetter(key[0])) {
    return 0;
  }

  let length = 1;

  for (let index = 1; index < key.length; index += 1) {
    const current = key[index];
    const next = key[index + 1];

    if (!isUppercaseLetter(current)) {
      break;
    }

    if (next && isLowercaseLetter(next)) {
      break;
    }

    length = index + 1;
  }

  return length;
}

function toCamelKey(key) {
  if (typeof key !== 'string' || !key) {
    return key;
  }

  if (!isUppercaseLetter(key[0])) {
    return key;
  }

  const acronymLength = getLeadingUppercasePrefixLength(key);
  if (acronymLength > 1) {
    return `${key.slice(0, acronymLength).toLowerCase()}${key.slice(acronymLength)}`;
  }

  return `${key[0].toLowerCase()}${key.slice(1)}`;
}

function toPascalKey(key) {
  if (typeof key !== 'string' || !key) {
    return key;
  }

  if (isUppercaseLetter(key[0])) {
    return key;
  }

  return `${key[0].toUpperCase()}${key.slice(1)}`;
}

function transformKeysDeep(value, keyTransformer) {
  if (Array.isArray(value)) {
    return value.map((entry) => transformKeysDeep(entry, keyTransformer));
  }

  if (!isPlainObject(value)) {
    return value;
  }

  return Object.entries(value).reduce((result, [key, entryValue]) => {
    result[keyTransformer(key)] = transformKeysDeep(entryValue, keyTransformer);
    return result;
  }, {});
}

function unwrapApiEnvelope(value) {
  if (Array.isArray(value)) {
    return value;
  }

  if (!isPlainObject(value)) {
    return value;
  }

  if (Array.isArray(value.$values)) {
    return value.$values;
  }

  if (Array.isArray(value.items)) {
    return value.items;
  }

  if (Array.isArray(value.results)) {
    return value.results;
  }

  if (Array.isArray(value.data)) {
    return value.data;
  }

  if (isPlainObject(value.data) && Object.keys(value).length === 1) {
    return value.data;
  }

  if (isPlainObject(value.value) && Object.keys(value).length === 1) {
    return value.value;
  }

  if (Array.isArray(value.value)) {
    return value.value;
  }

  return value;
}

export function fromApiData(value) {
  return unwrapApiEnvelope(transformKeysDeep(value, toCamelKey));
}

export function toApiData(value) {
  return transformKeysDeep(value, toPascalKey);
}

export function shouldTransformRequestBody(value) {
  return Array.isArray(value) || isPlainObject(value);
}
